// 获取当前应用环境
export const getAppEnv = () => {
  const envMap = {
    dev: ['qa', 'dev'],
    test: ['sit', 'test'],
    stg: ['stg']
  }

  const { host = '' } = window.location
  const envList = Object.keys(envMap)

  for (let i = 0; i < envList.length; i += 1) {
    const env = envList[i]
    const envNameList = envMap[env]

    for (let j = 0; j < envNameList.length; j += 1) {
      const envName = envNameList[j]
      
      if (host.indexOf(`-${envName}.`) > -1) {
        return env
      }
    }
  }

  return 'prod'
}

// 驼峰转下划线
export const humpToLine = key => {
  return (key || '').replace(/([A-Z])/g, '_$1').toLowerCase()
}

// 获取用户域账号
// 方式一：从localstorage中提取lastUser
export const getWorkerUserId = () => {
  if (window.localStorage) {
    let lastUser = (window.localStorage.getItem('lastUser') || '')
      .replace('@nio.com', '')
      .replace('@nio.io', '')
      .replace('@niocapital.com', '')
    
    if (lastUser && /^[a-z]+\.[a-z]+[1-9]*(\.o)?$/.test(lastUser)) {
      return lastUser
    }
  }

  return ''
}
  